import { publicConfig } from '@/config/public-config';

const MODE_LABELS: Record<typeof publicConfig.DEPLOYMENT_MODE, string> = {
  demo_local: 'Démo locale — données fictives, mocks autorisés, aucun usage financier réel',
  private_staging: 'Pré-recette privée — sandbox/test uniquement, aucun paiement live',
  private_production: 'Production privée',
};

export function EnvironmentBanner() {
  if (publicConfig.DEPLOYMENT_MODE === 'private_production') return null;

  return (
    <div
      role="status"
      aria-label="Mode d'exécution SolarCell"
      className="sticky top-0 z-50 max-w-full border-b border-amber-300 bg-amber-50 px-4 py-2 text-center text-xs font-semibold leading-snug text-amber-900 shadow-sm sm:text-sm"
    >
      {MODE_LABELS[publicConfig.DEPLOYMENT_MODE]}
    </div>
  );
}
